// extracted by mini-css-extract-plugin
export var cart = "CartContent_cart__oMo2n";
export var cartContentWrapper = "CartContent_cartContentWrapper__0EdXS";
export var scrollContain = "CartContent_scrollContain__NhS4L";
export var shared = "\"../../../shared/shared.module.css\"";
export var sm = "576px";